import { Form, Input, Select } from "@pankod/refine-antd";
import { MyFormProps } from ".";
import { IRole } from "interfaces";
import { UserRole } from "enums";

export const UsersForm: React.FC<MyFormProps> = ({ formProps, isEdit }) => {
  const roles: Array<IRole> = [
    {
      value: UserRole.Admin,
      label: "Administrador do Sistema",
    },
    {
      value: UserRole.ReportsFull,
      label: "Relatórios Completo",
    },
    {
      value: UserRole.ReportsBasic,
      label: "Relatórios Básico",
    },
  ];
  return (
    <Form {...formProps} layout="vertical">
      <Form.Item
        label="Nome"
        name="name"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="E-Mail"
        name="email"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input />
      </Form.Item>
      {!isEdit && (
        <Form.Item
        label="Senha"
        name="secret"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input />
      </Form.Item>
      )}
      <Form.Item
        label="Perfil"
        name="role"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Select options={roles} />
      </Form.Item>
    </Form>
  );
};
